import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

/** Chiave sessionStorage che segna un reload gia' tentato per chunk mancante (guardia anti-loop). */
export const CHUNK_RELOADED_KEY = 'chunkReloaded';

@Injectable()
export class ChunkErrorHandler implements ErrorHandler {
  private sentryHandler = Sentry.createErrorHandler({ showDialog: false });

  handleError(err: any): void {
    const chunkFailedMessage =
      /dynamically imported module|Importing a module script failed|'text\/html' is not a valid JavaScript MIME type/i;
    if (chunkFailedMessage.test(err?.message)) {
      // Ricarica una sola volta: se dopo il reload il chunk manca ancora
      // (es. errore durante il bootstrap) si eviterebbe altrimenti un loop infinito.
      // Il flag viene azzerato da AppComponent su una navigazione andata a buon fine.
      if (!this.hasReloadFlag()) {
        this.setReloadFlag();
        this.reload();
      } else {
        // Reload gia' tentato: logga a Sentry invece di ricaricare all'infinito.
        this.sentryHandler.handleError(err);
      }
      return;
    }
    if (err instanceof HttpErrorResponse) {
      return;
    }
    this.sentryHandler.handleError(err);
  }

  private hasReloadFlag(): boolean {
    return !!sessionStorage.getItem(CHUNK_RELOADED_KEY);
  }

  private setReloadFlag(): void {
    sessionStorage.setItem(CHUNK_RELOADED_KEY, '1');
  }

  private reload(): void {
    window.location.reload();
  }
}
